import React, { Component } from 'react';
import ContentText from './ContentText';


export default class extends Component {
    render() {
        const { BoxActions } = this.props;

        // TAB 메뉴
        var tabMenu = [];

        for (var i = 0; i < this.props.tabMenu.length; i++) {
            tabMenu.push(<a key={i} target={i} className={"btn-tab " + (this.props.selectTab == i ? "active" : "")}
                onClick={function (e) {
                    BoxActions.updateTab(e.target.getAttribute("target"));
        }.bind(this)
            }> {this.props.tabMenu[i]}</a >);
        }

        function video(src) {
            return (
                <div className="content-video pc">
                    <iframe src={src} frameBorder="0" width="670" height="376" allowFullScreen></iframe>
                </div>
            );
        }

        function img(src) {
            return <img src={src} alt="" className="content-img pc"/>;
        }

        return (
            <div className="content-main" id="content-main">
                <div className="content-main-box">
                    {(this.props.isYoutubeUrl) ? video(this.props.youtubeUrl) : img(this.props.mainImgUrl)}
                </div>
                
                <div className="content-tab">
                    <div className="content-tab-menu">
                        {tabMenu}
                    </div>
                </div>
                <ContentText content={this.props.content0} tabMenuClass={this.props.tabMenuClass[0]} isShow={this.props.selectTab == "0" ? true : false}/>
                <ContentText content={this.props.content1} tabMenuClass={this.props.tabMenuClass[1]} isShow={this.props.selectTab == "1" ? true : false}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/ContentMain.js